import axios from "axios";
import { addAuthToken } from "./axios";

const ecomApi = axios.create({
  baseURL : `https://menastockinstore.com/api/`,
});

ecomApi.interceptors.request.use(
  addAuthToken,
  (error) => Promise.reject(error)
);

export default ecomApi;